<template>
  <article class="login">
    <div class="login_wrapper">
      <div class="login_title base_title">{{ pageTitle }}</div>
      <form class="login_form" @submit.prevent="userAuth" v-if="!register">
        <input type="text" class="input_wide" required autofocus autocomplete="off"
          v-model="user.username" placeholder="Логин или email">
        <input type="password" class="input_wide" required placeholder="Пароль"
          v-model="user.password">
        <div class="form_row">
          <checkbox id="remme" text="Запомнить пароль" v-model="user.remember"/>
          <router-link to="/lost" class="base_link">
            Забыли пароль?
          </router-link>
        </div>
        <button type="submit" class="btn btn_submit">Войти</button>
        <div class="divider">или</div>
        <button type="button" class="btn btn_submit alt"
          @click="register=true">Создать аккаунт</button>
      </form>
      <form class="login_form" @submit.prevent="createUser" v-else>
        <input type="text" required autocomplete="off" placeholder="Логин" class="input_wide"
          v-model="newUser.username">
        <input type="email" required autocomplete="off" placeholder="Email" class="input_wide"
          v-model="newUser.email">
        <input type="password" required autocomplete="off" class="input_wide" placeholder="Пароль"
          v-model="newUser.password1">
        <input type="password" required autocomplete="off" class="input_wide"
          placeholder="Повторите пароль" v-model="newUser.password2">
        <button type="submit" class="btn btn_submit">Создать аккаунт</button>
        <div class="divider">или</div>
        <button type="button" class="btn btn_submit alt"
          @click="register = false">Войти</button>
      </form>
      <div class="auth_icon"></div>
    </div>
  </article>
</template>
<script>
import checkbox from '../components/checkBox';

export default {
  name: 'Auth',
  components: { checkbox },
  data() {
    return {
      user: {
        username: null,
        password: null,
        remember: false,
      },
      register: false,
      newUser: {
        username: null,
        email: null,
        password1: null,
        password2: null,
      },
    };
  },
  methods: {
    userAuth() {
      this.$store.dispatch('login', this.user)
        .then((resp) => {
          if (resp.status === 'success') {
            this.$notify({
              type: 'success',
              text: 'Вы успешно авторизованы',
            });
            setTimeout(() => {
              this.$router.push('/');
              location.reload();
            }, 2500);
          } else {
            this.$notify({
              type: resp.status,
              text: resp.message,
            });
          }
        });
    },
    createUser() {
      const passes = [this.newUser.password1, this.newUser.password2];
      const data = {
        ...this.newUser,
        passwords: passes,
      };
      delete data.password1;
      delete data.password2;
      this.$store.dispatch('register', data)
        .then((resp) => {
          if (resp.status === 'success') {
            this.$notify({
              type: 'success',
              text: 'Аккаунт успешно создан',
            });
            setTimeout(() => {
              this.$router.push('/');
            }, 2500);
          } else {
            this.$notify({
              type: resp.status,
              text: resp.message,
            });
          }
        });
    },
  },
  computed: {
    pageTitle() {
      return this.register ? 'Регистрация' : 'Авторизация';
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.login{
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before{
    position: absolute;
    z-index: -1;
    content: '';
    height: 80%;
    width: 100%;
    top: 10%;
    left: 0%;
    filter: blur(100px);
    mix-blend-mode: color-dodge;
    background: radial-gradient(35.24% 50% at 50% 50%, rgb(61, 224, 87) 0%, rgb(31, 31, 31) 100%);
  }
  &_wrapper{
    padding: 40px 30px 25px 30px;
    background: $black;
    border-radius: 20px;
    font-family: $font;
    min-width: 400px;
    position: relative;
    .auth_icon{
      position: absolute;
      background: url('/static/auth-icon.png') no-repeat 50% 50% / contain;
      height: 87px;
      width: 104px;
      top: calc(0% - 76px);
      right: 30px;
    }
  }
  &_form{
    max-width: 450px;
    .input_wide{
      margin-bottom: 15px;
    }
    .form_row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      color: white;
      user-select: none;
    }
    .divider{
      width: 100%;
      text-align: center;
      line-height: 20px;
      color: white;
      opacity: .6;
      user-select: none;
    }
    .second{
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Auth.vue